import { call, put, takeEvery } from "redux-saga/effects";
import { donHangApi } from "../../../api/don-hang/donHangApi";
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { eDonHangViewChiTietActionIds, IDonHangViewChiTietActionTypes } from "../../action-types/don-hang/IDonHangViewChiTietActions";
import { rootActions } from '../../actions/rootActions';
const mainAction = rootActions.donHang.donHangViewChiTiet;
export function* donHangViewChiTietSaga(): any {
    yield takeEvery(eDonHangViewChiTietActionIds.GET_HTML_PRINT_START, getHtmlPrintWorker)

}

function* getHtmlPrintWorker(action: IDonHangViewChiTietActionTypes): any {
    const id = action.payload as number;
    const res: IBaseRespone = yield call(donHangApi.GetHtmlPrint, id)
    if (res.is_success) {
        yield put(mainAction.GET_HTML_PRINT_SUCCESS({
            donHangId: id,
            data: res.data
        }))
    } else {
        yield put(mainAction.GET_HTML_PRINT_ERROR({
            donHangId: id,
            data: res.message ?? "Có lỗi"
        }))
    }
}
